import React from "react";

import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col } from "react-bootstrap";

import { NavLink } from "react-router-dom";

import { FaFacebookF, FaInstagram, FaPinterest, FaTwitter, FaYoutube, FaCheck, FaSketch, FaOpencart } from "react-icons/fa";
import { BsSendCheck, BsFill1CircleFill, BsFill2CircleFill, BsCheckLg, BsFillRecordFill, BsFacebook, BsInstagram, BsTelephone, BsSend, BsTiktok } from "react-icons/bs";

function Contact() {

    return (

        <Container>

            <br/>

            <h3><strong><BsSend/> ติดต่อเรา</strong></h3>
          
            <h3 className="pb-3 border-bottom"></h3>
            <br/>
            {/* <h4><strong>ที่อยู่ EnqueX</strong></h4>
            <p>เลขที่ 199/288 แขวงสีกัน เขตดอนเมือง กรุงเทพมหานคร รหัสไปรษณีย์ 10210</p>

            
          
            <br/> */}

            <h4><strong>ช่องทางติดต่อเรา</strong></h4>
            <p><a href="https://www.facebook.com/profile.php?id=100028543045358&mibextid=LQQJ4d" target="_blank" rel="noreferrer" style={{textDecoration: 'none'}}><BsFacebook/> Facebook Messenger</a><br/>
            <a href="https://www.instagram.com/chicchic_pichitnati?igsh=d3MyZHQzNnAybnBh" target="_blank" rel="noreferrer" style={{textDecoration: 'none'}}><BsInstagram/> Instagram Direct Messages</a><br/>
            <a href="https://www.tiktok.com/@chichic.codeoflaw?_t=8mmKa9uNKfi&_r=1" target="_blank" rel="noreferrer" style={{textDecoration: 'none'}}><BsTiktok /> TikTok</a><br/>
            </p>
            {/* โทรศัพท์ - <BsTelephone/> 0805514821</p> */}

            

            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
           
            

        </Container>

    );

}

export default Contact;